import React from 'react';
import { Card, Descriptions, Spin } from 'antd';
import { formatAmount } from './purchaseDealSheet.helpers';

export default function FinancialSummaryCard({ amounts, loading = false, title = 'Financial Summary' }) {
  const items = [
    { key: 'consideration', label: 'Consideration', value: amounts?.consideration ?? amounts?.total_consideration },
    { key: 'stamp_duty', label: 'Stamp Duty', value: amounts?.stamp_duty_amount },
    { key: 'tds', label: 'TDS', value: amounts?.tds_amount },
    { key: 'total', label: 'Total Payable', value: amounts?.total_payable ?? amounts?.total_amount },
  ];

  return (
    <Card
      title={title}
      size="small"
      className="shadow-sm border-gray-100"
      styles={{ body: { padding: '12px 16px' } }}
    >
      {loading ? (
        <div className="flex justify-center py-6">
          <Spin />
        </div>
      ) : amounts ? (
        <Descriptions column={1} size="small" colon={false}>
          {items.map((item) => (
            <Descriptions.Item
              key={item.key}
              label={<span className="text-gray-500">{item.label}</span>}
            >
              <span className={item.key === 'total' ? 'font-semibold text-base text-gray-900' : 'text-gray-800'}>
                ₹ {formatAmount(item.value)}
              </span>
            </Descriptions.Item>
          ))}
        </Descriptions>
      ) : (
        <p className="text-sm text-gray-400 italic m-0">
          Enter quantity and price to see calculated amounts.
        </p>
      )}
    </Card>
  );
}
